import {FormikProps} from 'formik';
import {IDirectDocsForm} from './formDetails';
import {ChangeEvent} from 'react';
import InputField from '../../../../../components/simpleInput';
import {ShowFormError} from '../../../../../utilities/helper/showFormError';

interface IProps {
  form: FormikProps<IDirectDocsForm>;
}

const PostalCodeInput = ({form}: IProps) => {
  return (
    <>
      <InputField
        name="postalCode"
        label="کد پستی"
        required
        type="number"
        max={10}
        placeholder="کد پستی را وارد کنید"
        value={form.values.postalCode || ''}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          if (e.target.value.length === 11) return;
          form?.setFieldValue('postalCode', e.target.value);
        }}
      />

      <ShowFormError field="postalCode" form={form} />
    </>
  );
};

export default PostalCodeInput;
